const config = {
  // API_URL: "http://localhost:3000/api",
  API_URL: "https://admin.mainapayal.com/api",
  // API_URL: "https://brown-cattle-554352.hostingersite.com/api",
};

export default config;
